import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Kampanjat',
  filters: {
    search: 'Hae kampanjoita...',
  },
  columns: {
    title: 'Otsikko',
    created_by: 'Luonut',
    schedule_mode: 'Ajoitustapa',
    scheduled_at: 'Ajoitettu',
    sent_at: 'Lähetetty',
    status: 'Tila',
    sent: 'Lähetetty',
    delivered: 'Toimitettu',
    delivered_rate: 'Toimitusaste',
    clicks: 'Klikkaukset',
    click_rate: 'Klikkausaste',
    live: 'Käynnissä',
    actions: 'Toiminnot',
  },
  active_status: {
    draft: 'Luonnos',
    active: 'Aktiivinen',
  },
  delivery: {
    in_progress: 'Odottaa vahvistusta',
    awaiting: 'Odottaa vahvistusta',
    verified: 'Vahvistettu {{relative}}',
    next_check_around: 'Seuraava tarkistus noin {{time}}',
  },
  breakdown: {
    delivered: '{{count}} toimitettu',
    pending: '{{count}} odottaa vahvistusta',
    failed_title: 'Ei toimitettu',
    all_delivered: 'Toimitettu kaikille vastaanottajille.',
    load_error: 'Toimitusyhteenvedon lataaminen epäonnistui.',
    reasons: {
      DeviceNotRegistered: 'Sovellus poistettu tai ilmoitukset pois päältä (vanhentunut tunnus)',
      MessageRateExceeded: 'Expo rajoittaa tilapäisesti nopeutta',
      MessageTooBig: 'Ilmoituksen sisältö liian suuri',
      MismatchSenderId: 'Push-tunnistetiedot eivät täsmää',
      InvalidCredentials: 'Virheelliset push-tunnistetiedot',
      batch_failed: 'Erän lähetys epäonnistui',
      missing_ticket: 'Expo ei palauttanut vahvistusta',
      unknown: 'Tuntematon toimitusvirhe',
    },
  },
  created_by: {
    [CreatedBy.System]: 'Järjestelmä',
    [CreatedBy.User]: 'Käyttäjä',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Heti',
    [ScheduleMode.Scheduled]: 'Ajoitettu',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Lähetetään',
    [DeliveryStatus.Sent]: 'Lähetetty',
    [DeliveryStatus.Queued]: 'Jonossa',
    [DeliveryStatus.Failed]: 'Epäonnistui',
  },
  actions: {
    details: 'Tiedot',
    view_details: 'Näytä tiedot',
    resend: 'Lähetä uudelleen',
    duplicate_edit: 'Kopioi ja muokkaa',
    delete: 'Poista',
    edit: 'Muokkaa',
    activate: 'Aktivoi',
    deactivate: 'Poista käytöstä',
  },
  success_messages: {
    campaign_updated: 'Kampanja päivitetty onnistuneesti',
    campaign_deleted: 'Kampanja poistettu onnistuneesti',
  },
  error_messages: {
    failed_to_update_campaign: 'Kampanjan päivitys epäonnistui',
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_delete_campaign: 'Kampanjan poistaminen epäonnistui',
  },
};
